import env from 'config/environment';
import { RootState } from '../reducer';

/**
 * Select function for settings.development. When the environment is in
 * development, it returns the object. Otherwise, returns false for all
 * properties (despite the Store state).
 */
export const getDevSettings = (state: RootState): RootState['settings']['development'] => {
  if (env.IsDevelopment() === true) { return state.settings.development; }

  return {
    showAllFieldErrors: false,
    showRenderDebugger: false,
    showFieldErrorVerbose: false,
  };
};
